export type SubContractorsStore = {
  isFetchSubcontractors: boolean;
};

export const initialState: SubContractorsStore = {
  isFetchSubcontractors: false,
};
